import React from 'react'

// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { Treemap } from 'react-vis'
import PropTypes from 'prop-types'

import './DynamicTreemap.css'

export class DynamicTreemap extends React.Component {
  constructor() {
    super()

    this.state = {
      modeIndex: 0,
      useSVG: true,
      clickedCell: false
    }
  }

  componentDidMount = () => {
    const tipStyle = {
      display: 'flex',
      color: '#fff',
      background: '#000',
      alignItems: 'center',
      padding: '5px'
    }
    const boxStyle = { height: '10px', width: '10px' }
  
    this.setState({
      tipStyle: tipStyle,
      boxStyle: boxStyle
    })
  }

  render = () => {
    const { data, primary, secondary } = this.props
    
    const STYLE = {
      border: 'thin solid #ddd'
    }

    const pivotfield = ['doc_ext']
    const query = '*:*'

    return (
      <div className="ospreyBackoffice_treemapWrapper">
        <div className="ospreyBackoffice_treemap">
          <Treemap {...{
            animation: false,
            className: 'nested-tree-example',
            colorType: 'literal',
            colorRange: ['#88572C'],
            data: data,
            mode: 'squarify',
            renderMode: 'DOM',
            height: 400,
            width: 800,
            margin: 10,
            getSize: (d) => d.count,
            getColor: (d) => d.color,
            style: STYLE,

            onLeafMouseOver: (v) => this.props.onHover(v, primary, secondary, query, pivotfield),
            onLeafMouseOut: () => this.props.unHover(),

            onLeafClick: (v) => this.props.onSelect(v, primary, secondary, query, pivotfield),
          }}>
          </Treemap>
        </div>
      </div>
    )
  }
}

DynamicTreemap.propTypes = {
  onHover: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  unHover: PropTypes.func.isRequired
}

export default DynamicTreemap